import React, { ImgHTMLAttributes } from 'react';

type Props = ImgHTMLAttributes<SVGElement>;

const ArrowReturn: React.FC<Props> = ({ className }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      d='M5.5 5H4V14.22H17.1297L13.41 17.9397L14.4706 19.0004L20.001 13.47L14.4706 7.9397L13.41 9.00036L17.1296 12.72H5.5V5Z'
      fill='currentColor'
      fillOpacity={1}
    />
  </svg>
);

export { ArrowReturn };
